<template>
  <div>
    <div
      class="tags-editor">
      <div
        class="tags-editor-title">
        {{ $t('variables.tags') }}
      </div>
      <tags
        :value="selectedTags"/>
    </div>
    <liquor-tree
      ref="tree"
      class="tree--small"
      @node:checked="onCheckedNode"
      @node:unchecked="onCheckedNode"
      :options="{ dnd: false, checkbox: true, multiple: false, parentSelect: false }">
      <div
        slot-scope="{ node }"
        class="node-container">
        <font-awesome-icon
          v-if="node.data.id < 0"
          class="icon"
          v-on:click="onEditNode(node)"
          :icon="icon.lock"/>
        <span class="node-text">{{ node.text }}</span>
      </div>
    </liquor-tree>
  </div>
</template>

<script>
import LiquorTree from 'liquor-tree';
import Tags from '@/components/variable/Tags';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons';

export default {
  name: 'TagsEditor',
  components: {
    Tags,
    LiquorTree,
    FontAwesomeIcon
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    tree: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    tree: function (tree) {
      const tags = this.selectedTags;
      this.selectTags(tags, tree);
      this.$refs.tree.setModel(tree);
    }
  },
  data () {
    return {
      selectedTags: this.value,
      systemTags: this.value.filter(tag => tag.id < 0),
      icon: {
        lock: faLock
      }
    };
  },
  methods: {
    selectTags (tags, nodes) {
      let expanded = false;

      for (let i = 0; i < nodes.length; i++) {
        let parentExpanded = this.selectTags(tags, nodes[i].children);

        const id = nodes[i].data.id;
        const tag = tags.find(tag => tag.id === id);
        if (tag) {
          nodes[i].state = { checked: true };
          expanded = true;
        } else {
          nodes[i].state = { expanded: parentExpanded };
        }
      }
      return expanded;
    },
    onCheckedNode (node) {
      this.forceSystemTags(node);

      this.selectedTags = [];
      this.updateSelectedTags(this.$refs.tree.checked());
      this.$emit('input', this.selectedTags);
    },
    updateSelectedTags (nodes) {
      for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        if (node.children.length === 0 && node.states.checked === true) {
          const included = this.selectedTags.map(tag => tag.id).includes(node.data.id);
          if (!included) {
            this.selectedTags.push({
              id: node.data.id,
              name: node.data.text
            });
          }
        } else if (node.children.length > 0) {
          this.updateSelectedTags(node.children);
        }
      }
    },
    forceSystemTags (node) {
      const include = this.systemTags.map(tag => tag.id).includes(node.data.id);
      if (include === true) {
        node.check();
      } else if (node.data.id < 0) {
        node.uncheck();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";

  .tags-editor {
    display: flex;
    align-items: center;
  }

  .tags-editor-title {
    color: $black-trans4;
    font-size: $fs-l;
    margin-right: $sp-margin;
  }

  .node-container {
    display: flex;
    align-items: center;
  }

  .icon {
    margin-right: $sp-margin-smaller;
  }

</style>



// WEBPACK FOOTER //
// src/components/variable/TagsEditor.vue